var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.377 3.503a3.036 3.036 0 0 1 2.126 2.15c.504 1.893.497 5.84.497 5.84s0 3.954-.504 5.846a3.049 3.049 0 0 1-2.126 2.151c-1.87.51-9.374.51-9.374.51s-7.504 0-9.367-.503a3.036 3.036 0 0 1-2.126-2.15C0 15.453 0 11.5 0 11.5s0-3.954.497-5.847A3.026 3.026 0 0 1 2.622 3.51C4.492 3 11.996 3 11.996 3s7.51 0 9.381.503zM15.839 11.5l-6.247 3.644V7.856L15.84 11.5z"
})));
export default SvgYoutube;